export default __webpack_public_path__ + "css/supplierPurchaseOrderPdf.bundle.css";